enum ChatPromptType {
  CONTENT = 'Content',
  URL = 'Url',
  CHATGPT = 'ChatGpt',
  DATABASE = 'Database',
  VALUE = 'Value',
  PROCESS = 'Process',
  ASSISTANT = 'Assistant',
  BI = 'BI',
  WEB_DOCUMENT = 'WebDocument',
  GENERAL = 'General',
  AGENT = 'Agent',
}

enum CiaGroup {
  AJUDA = 'Ajuda',
  AGENTES = 'Agentes',
  ANALISAR = 'Analisar',
  AUDITOR = 'Auditor',
  CONSULTAR = 'Consultar',
  FACA = 'Faça',
  GERAL = 'Geral',
  IA_GENERATIVA = 'IA Generativa',
  INSIGHTS = 'Insights',
  LISTAR = 'Listar',
  PAINEIS = 'Painéis do BI',
  PESQUISA_INTERNET = 'Pesquisa na internet',
  PORTAIS = 'Portais',
  QUAL = 'Qual',
  RELATORIOS = 'Relatórios',
  VIDEOS = 'Vídeos',
}

export { ChatPromptType, CiaGroup };
